export default "__VITE_ASSET__2360e324__"